import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Successimg from '../../Components/SuccessStories/Successimg';
import SuccessText from '../../Components/SuccessStories/SuccessText';
import ClientSay from '../../Components/SuccessStories/ClientSay';

function SuccessStories() {
    
  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0 }} >
        <div>
          <Header title="success" />
        </div>

        <div>
          <Successimg/>
        </div>
        
        <div>
          <SuccessText/>
        </div>

        <div>
          <ClientSay/>
        </div>
        

     <div>
      <Footer/>
     </div>

      </Container>
    </div>
    
  );
}

export default SuccessStories